import 'babel-polyfill'
import connectToStores from 'alt-utils/lib/connectToStores'
import { ExtendedUserActions } from 'actions'
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider'
import getMuiTheme from 'material-ui/styles/getMuiTheme'
import theme from '../theme'
import { UserStore, Analytics } from 'common-frontend'
import { NpsUtils } from 'utils'
import { NpsStore } from 'stores'
import { NpsContainer } from 'containers'
import { Header, Footer, GlobalError } from 'components'
import { Link } from 'react-router'
import Helmet from 'react-helmet'

import './appContainer.scss'

@connectToStores
export default class AppContainer extends React.Component {
  static childContextTypes = {
    authenticated: React.PropTypes.bool,
    currentUser: React.PropTypes.object
  }

  getChildContext() {
    if (this.props.currentUser) {
      // We have renamed plus to activeCharge. Since we store currentUser in local storage, there could
      //  be some users who go directly to the app and have plus but not activeCharge. This patch is to support
      //  them until they eventually log in from Shopify again, refreshing their local storage currentUser.
      if (this.props.currentUser.plus !== undefined && this.props.currentUser.activeCharge === undefined) {
        this.props.currentUser.activeCharge = this.props.currentUser.plus
      }
    }
    return {
      authenticated: this.props.authenticated,
      currentUser: this.props.currentUser
    }
  }

  static contextTypes = {
    router: React.PropTypes.object.isRequired
  }

  static propTypes = {
    header: React.PropTypes.object,
    nav: React.PropTypes.object,
    content: React.PropTypes.object.isRequired,
    footer: React.PropTypes.object
  }

  static defaultProps = {
    header: <Header />,
    footer: <Footer />
  }

  componentWillMount() {
    if (this.props.authenticated)
      ExtendedUserActions.getCurrent(this.props.currentUser.accessToken)

    this.analyticsPageView(this.props.location.pathname, this.props.location.search)
  }

  componentDidUpdate(prevProps) {
    // do this after update to pick up new page title from Helmet
    this.analyticsPageView(this.props.location.pathname, this.props.location.search)
  }

  // This component is the router root component, so receives new props whenever navigating
  analyticsPageView(pathname, search) {
    Analytics.page({
      path: pathname,
      search: search
    })
  }

  static getStores() {
    return [UserStore, NpsStore]
  }

  static getPropsFromStores() {
    return {
      ...UserStore.getState(),
      ...NpsStore.getState()
    }
  }

  render() {
    const header = this.props.header === null ? null : <header>{ this.props.header }</header>
    const nav = this.props.nav === null ? null : <nav>{ this.props.nav }</nav>
    const footer = this.props.footer === null ? null : <Footer className='footer' currentUser={this.props.currentUser}>{ this.props.footer }</Footer>
    const nps = NpsUtils.shouldRender(this.props.location.pathname, this.props.currentUser, this.props.npsDismissed, this.props.npsScore, this.props.npsShowAfter) && <NpsContainer />

    return (
      <MuiThemeProvider muiTheme={getMuiTheme(theme)}>
        <div>
          <Helmet title='Plug in SEO' />
          { header }
          { nav }
          <section className='content'>
            { this.props.content }
          </section>
          { footer }
          <GlobalError />
          { nps }
        </div>
    </MuiThemeProvider>
    )
  }
}



// WEBPACK FOOTER //
// ./app/containers/AppContainer.js